import { render, staticRenderFns } from "./PhysicalExerciseEditForm.vue?vue&type=template&id=f6f683be&"
import script from "./PhysicalExerciseEditForm.vue?vue&type=script&lang=ts&"
export * from "./PhysicalExerciseEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports